// @flow
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { colors } from '../../shared/styles';

type PropertyNavProps = {
    mode?: string,
    propertyReference?: string,
    sectionStatuses?: any,
};

const StyledPropertyNav = styled.div`
    flex: 0 0 300px;
    background: ${colors.grey.default};
    color: ${colors.white};

    & h2 {
        margin: 0;
        padding: 20px 30px 20px 30px;
        font-weight: lighter;
        border-bottom: solid 1px ${colors.grey.light};
    }

    & ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    & li {
        position: relative;
        display: block;
        border-bottom: solid 1px ${colors.grey.light};
        line-height: 20px;
    }

    & li a,
    & li span {
        display: block;
        padding: 20px 30px;
        color: #fff;
        text-decoration: none;
    }

    & .active {
        background: ${colors.grey.light};
    }

    & .active::after {
        position: absolute;
        content: "";
        width: 0;
        height: 0;
        right: 0;
        top: 16px;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-right: 15px solid #edf1f2;
    }

    & li i {
        font-size: 20px;
        margin-right: 10px;
        color: ${colors.white};
        vertical-align: bottom;
    }
`;

const PropertyNav = (props: PropertyNavProps) => {
    const { propertyReference, mode, sectionStatuses } = props;

    let title = 'Add New Property';

    if (mode !== 'add' && propertyReference) {
        title = `Edit ${propertyReference}`;
    }

    const statusIcons = sectionStatuses
        ? Object.keys(sectionStatuses).reduce((result, key) => {
              result[key] =
                  sectionStatuses[key] === true
                      ? 'fa fa-circle-o'
                      : 'fa fa-check-circle';
              return result;
          }, {})
        : {};

    return (
        <StyledPropertyNav>
            <h2>
                {title}
            </h2>

            {mode === 'add' &&
                <ul>
                    <li>
                        <span className="active">
                            <i className="fa fa-circle" aria-hidden="true" />
                            Location
                        </span>
                    </li>
                    <li>
                        <span>
                            <i className="fa fa-circle-o" aria-hidden="true" />
                            Description
                        </span>
                    </li>
                    <li>
                        <span>
                            <i className="fa fa-circle-o" aria-hidden="true" />
                            Key Information
                        </span>
                    </li>
                    <li>
                        <span>
                            <i className="fa fa-circle-o" aria-hidden="true" />
                            Costs
                        </span>
                    </li>
                    <li>
                        <span>
                            <i className="fa fa-circle-o" aria-hidden="true" />
                            Contacts
                        </span>
                    </li>
                    <li>
                        <span>
                            <i className="fa fa-circle-o" aria-hidden="true" />
                            Media
                        </span>
                    </li>
                    <li>
                        <span>
                            <i className="fa fa-circle-o" aria-hidden="true" />
                            Activity Log
                        </span>
                    </li>
                </ul>}

            {propertyReference &&
                <ul>
                    <li>
                        <NavLink
                            to={`/property/edit/${propertyReference}`}
                            activeClassName="active"
                            exact
                        >
                            <i
                                className={statusIcons.location}
                                aria-hidden="true"
                            />
                            Location
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/property/edit/${propertyReference}/description`}
                            activeClassName="active"
                        >
                            <i
                                className={
                                    statusIcons.description || 'fa fa-circle-o'
                                }
                                aria-hidden="true"
                            />
                            Description
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/property/edit/${propertyReference}/key-information`}
                            activeClassName="active"
                        >
                            <i
                                className={
                                    statusIcons.keyInformation ||
                                    'fa fa-circle-o'
                                }
                                aria-hidden="true"
                            />
                            Key Information
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/property/edit/${propertyReference}/costs`}
                            activeClassName="active"
                        >
                            <i
                                className={
                                    statusIcons.costs || 'fa fa-circle-o'
                                }
                                aria-hidden="true"
                            />
                            Costs
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/property/edit/${propertyReference}/contacts`}
                            activeClassName="active"
                        >
                            <i
                                className={
                                    statusIcons.contacts || 'fa fa-circle-o'
                                }
                                aria-hidden="true"
                            />
                            Contacts
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/property/edit/${propertyReference}/media`}
                            activeClassName="active"
                        >
                            <i
                                className={
                                    statusIcons.media || 'fa fa-circle-o'
                                }
                                aria-hidden="true"
                            />
                            Media
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to={`/property/edit/${propertyReference}/activity-log`}
                            activeClassName="active"
                        >
                            <i
                                className={
                                    statusIcons.media || 'fa fa-circle-o'
                                }
                                aria-hidden="true"
                            />
                            Activity Log
                        </NavLink>
                    </li>
                </ul>}
        </StyledPropertyNav>
    );
};

export default PropertyNav;



// WEBPACK FOOTER //
// ./src/components/shared/PropertyNav.js